export const CONTACT_EMAIL = 'hello@midnightswim.app';
